import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const HalfDay = ({
  status,
  selectedStatus,
  setStatus,
  staffData,
  summaryDate,
  shiftDetail,
  setStaffId,
  fetchAttendance,
}) => {
  console.log(shiftDetail);
  const { baseUrl, shift, openToast } = useGlobalContext();
  const [shiftType, setShiftType] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  function combineDateWithTimeAndFormat(time) {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12;

    const formattedTime = `${formattedHour}:${minutes} ${period}`;
    return `${formattedDate} ${formattedTime}`;
  }

  async function confirmation() {
    try {
      setIsLoading(true);
      if (status == "") {
        openToast("Please Select Status", "error");
        return;
      }
      const formattedStartTime = combineDateWithTimeAndFormat(startTime);
      const formattedEndTime = combineDateWithTimeAndFormat(endTime);

      const result = await fetch(
        baseUrl + `attendance/status/${staffData?.punchRecord?.[0]?.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
          body: JSON.stringify({
            punchDate: new Date(summaryDate),
            staffId: staffData?.staffId,
            status: selectedStatus,
            startTime: new Date(formattedStartTime),
            endTime: new Date(formattedEndTime),
            shiftId: shiftType
          }),
        }
      );
      if (result.status == 200) {
        openToast("Updated Status Successfully", "success");
        fetchAttendance();
        setStaffId(null);
        setStatus("");
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      setIsLoading(false);
    }
  }


  function getHourAndMinutes(isoString) {
    const date = new Date(isoString);
    return date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: false });
  }

  useEffect(() => {
    if (staffData?.punchRecord?.[0]?.status === "HALFDAY" && selectedStatus === "HALFDAY") {
      setStartTime(getHourAndMinutes(staffData?.punchRecord?.[0]?.punchIn?.punchInTime))
      setEndTime(getHourAndMinutes(staffData?.punchRecord?.[0]?.punchOut?.punchOutTime))
      setShiftType(staffData?.punchRecord?.[0]?.shift?.id)
    }
  }, [])

  console.log(startTime, shiftDetail)

  return (
    <Modal
      open={selectedStatus == "HALFDAY"}
      onClose={() => setStatus("")}
      center
    >
      <div className="pt-5">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="font-medium text-[22px] text-gray-900">HALFDAY</h1>
            <p className="text-gray-600 text-sm">
              {staffData?.staffDetails?.User?.name} | {summaryDate}
            </p>
          </div>
        </div>

        <div className="relative p-4 pr-0 pl-0">
          <div className="space-y-4">
            <div>
              <label className="block mb-1 text-[#000] text-sm">
                Shift Name
              </label>
              <div className="relative">
                <select
                  value={shiftType}
                  onChange={(e) => setShiftType(e.target.value)}
                  className="bg-white px-3 py-2 pr-10 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 appearance-none"
                >
                  <option>Select Shift</option>
                  {shift?.map((item) => {
                    return (
                      <option value={item?.id}>
                        {item?.shiftName} (
                        {item?.shiftStartTime + " to " + item?.shiftEndTime})
                      </option>
                    );
                  })}
                </select>
                <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <div className="gap-4 grid grid-cols-2 modal-present">
              <div>
                <label className="block mb-1 text-[#000] text-sm">
                  Start Time
                </label>
                <div className="relative">
                  <input
                    type="time"
                    onClick={(e) => e.target.showPicker()}
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    placeholder="Start Time"
                    className="px-3 py-2 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 placeholder-gray-400"
                  />
                  <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <div>
                <label className="block mb-1 text-[#000] text-sm">
                  End Time
                </label>
                <div className="relative">
                  <input
                    type="time"
                    onClick={(e) => e.target.showPicker()}
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    placeholder="End Time"
                    className="px-3 py-2 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 placeholder-gray-400"
                  />
                  <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          className={`second-btn flex items-center justify-center w-full ${isLoading == true ? "opacity-50 cursor-not-allowed" : ""
            }`}
          onClick={confirmation}
        >
          Save
        </button>
      </div>
    </Modal>
  );
};

export default HalfDay;
